export enum KeyCode {
  Enter = 13,
  BackSpace = 8
}
